const Date = {
    elemName: '日時',
    type: 'inline',
    doc: '日時情報をマークアップします。',
    example: '＜安政二年卯十月二日＞',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Date {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<date {{{$xmlId}}} {{{$xmlSubType}}}>{{{$1}}}</date>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$$1}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
export default Date;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvaW5saW5lX3J1bGVzL0RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxJQUFJLEdBQW1CO0lBQzVCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFFBQVE7SUFDZCxHQUFHLEVBQUUsaUJBQWlCO0lBQ3RCLE9BQU8sRUFBRSxhQUFhO0lBQ3RCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLFlBQVksRUFBRSxRQUFRO0lBQ3RCLFlBQVksRUFBRSwrREFBK0Q7SUFDN0UsV0FBVyxFQUFFLHNEQUFzRDtJQUNuRSxZQUFZLEVBQUUsMkVBQTJFO0lBQ3pGLGFBQWEsRUFBRSxXQUFXO0NBQzFCLENBQUM7QUFFRixlQUFlLElBQUksQ0FBQyJ9